import moment from 'moment';
import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'Manufacturers',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1)
                this.logout();
        }

        this.GetInfo();
    },

    mounted() {
        const el = document.getElementById('offcanvasManufacturerForm');
        if (el) {
            el.addEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    beforeDestroy() {
        const el = document.getElementById('offcanvasManufacturerForm');
        if (el) {
            el.removeEventListener('hidden.bs.offcanvas', this.onDrawerHidden);
        }
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },
        drawerTitle() {
            return this.drawerMode === 'create'
                ? `إضافة ${this.ScreenTitleSingle}`
                : `تعديل ${this.ScreenTitleSingle}`;
        },
        drawerSubtitle() {
            return this.drawerMode === 'create'
                ? 'أدخل بيانات الشركة المصنعة الجديدة.'
                : 'حدّث بيانات الشركة المصنعة من اللوحة الجانبية مباشرة.';
        },
        drawerSubmitLabel() {
            return this.drawerMode === 'create'
                ? `إضافة ${this.ScreenTitleSingle}`
                : 'حفظ التعديلات';
        },
        drawerDescription() {
            return this.drawerMode === 'create'
                ? 'سيتم تفعيل الشركة المصنعة مباشرة بعد الحفظ، ويمكنك إخفاؤها لاحقاً من قائمة الإجراءات.'
                : 'يمكنك تعديل الاسم والوصف، بينما تغيير حالة العرض يتم من قائمة الإجراءات داخل الجدول.';
        },
        currentStatusText() {
            if (this.drawerMode === 'create') return 'سيُفعّل مباشرة';
            return this.statusLabel(this.SelectedItem ? this.SelectedItem.status : 1);
        },
        currentStatusClass() {
            return this.statusBadgeClass(
                this.drawerMode === 'create' ? 1 : (this.SelectedItem ? this.SelectedItem.status : 1)
            );
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) return 'فارغ';
            return moment(date).format('DD/MM/YYYY');
        },
        momentTime: function (date) {
            if (date === null) return 'فارغ';
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: 'الشركات المصنعة',
            ScreenTitleSingle: 'شركة مصنعة',
            ScreenTitleSingleAl: 'الشركة المصنعة',

            Info: [],
            Statistics: [],

            SelectedItem: null,
            drawerMode: 'create',

            ruleForm: {
                Id: '',
                Name: '',
                Descriptions: '',
            },
            rules: {
                Name: this.$helper.Required(),
            },
        };
    },

    methods: {
        statusBadgeClass(status) {
            return Number(status) === 1 ? 'bg-label-success' : 'bg-label-warning';
        },
        statusLabel(status) {
            return Number(status) === 1 ? 'مفعل' : 'مخفي';
        },
        descriptionText(item) {
            return item && item.descriptions ? item.descriptions : 'بدون وصف إضافي';
        },
        manufacturerAvatarText(item) {
            const name = item && item.name ? item.name.trim() : '';
            if (!name) return 'MF';
            const parts = name.split(/\s+/).filter(Boolean);
            if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
            return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
        },
        tableRowNumber(index) {
            return ((Number(this.pageNo) - 1) * Number(this.pageSize)) + index + 1;
        },
        resetFormState() {
            this.ruleForm.Id = '';
            this.ruleForm.Name = '';
            this.ruleForm.Descriptions = '';
        },
        clearValidationState() {
            if (this.$refs.ruleForm && this.$refs.ruleForm.clearValidate) {
                this.$refs.ruleForm.clearValidate();
            }
        },
        showDrawer() {
            const el = document.getElementById('offcanvasManufacturerForm');
            if (el && window.bootstrap) {
                window.bootstrap.Offcanvas.getOrCreateInstance(el).show();
            }
        },
        hideDrawer() {
            const el = document.getElementById('offcanvasManufacturerForm');
            if (el && window.bootstrap) {
                const drawer = window.bootstrap.Offcanvas.getInstance(el) || window.bootstrap.Offcanvas.getOrCreateInstance(el);
                drawer.hide();
            }
        },
        onDrawerHidden() {
            this.clearValidationState();
        },
        openCreateDrawer() {
            this.drawerMode = 'create';
            this.SelectedItem = null;
            this.resetFormState();
            this.$nextTick(() => {
                this.clearValidationState();
            });
        },
        openEditDrawer(item) {
            this.drawerMode = 'edit';
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Descriptions = item.descriptions || '';
            this.$nextTick(() => {
                this.clearValidationState();
                this.showDrawer();
            });
        },
        showRequestError(title, err) {
            if (err.response && err.response.data) {
                this.$helper.ShowMessage('error', title, err.response.data);
            } else {
                this.$helper.ShowMessage('error', title, 'حدث خطأ غير متوقع');
            }
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo || this.pageNo || 1;

            if (!this.Search) this.$blockUI.Start();
            this.$http.GetManufacturers(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search) this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        submitDrawerForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.drawerMode === 'create') {
                        this.createManufacturer();
                    } else {
                        this.updateManufacturer();
                    }
                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        createManufacturer() {
            this.ruleForm.Id = Number(0);
            this.$blockUI.Start();
            this.$http.AddManufacturers(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(1);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية الإضافة', err);
                });
        },

        updateManufacturer() {
            this.ruleForm.Id = Number(this.ruleForm.Id);
            this.$blockUI.Start();
            this.$http.EditManufacturers(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.hideDrawer();
                    this.GetInfo(this.pageNo);
                    this.resetFormState();
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.showRequestError('خطأ بعملية التعديل', err);
                });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من عملية تغيير حالة العرض؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusManufacturers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية التعديل', err);
                        });
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية',
                text: 'هل أنت متأكد من عملية الحذف؟',
                icon: 'question',
                customClass: { confirmButton: 'btn btn-primary' },
                buttonsStyling: false,
                confirmButtonText: 'تأكيد العملية',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteManufacturers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            this.showRequestError('خطأ بعملية الحذف', err);
                        });
                }
            });
        },
    }
}
